export function BlockEmoji(text: string): string {
    const textArr = text.split('');
    const resArr = textArr.length ? textArr.filter((c) => isLetter(c)) : [];
    return text && resArr.length ? resArr.join('') : '';
}

function isLetter(c: string): boolean {
    const symbol = `^[a-zA-Z0-9_*\\\\+-/=!?%$#'’"-_|\n\\{\\} ]*$`;
    return (c.toLowerCase() !== c.toUpperCase()) || Boolean(c.match(symbol));
}
